import { Plugin } from 'ckeditor5';
import { TrackChanges } from 'ckeditor5-premium-features';

// TrackChangesIntegration Plugin
export default class TrackChangesIntegration extends Plugin {
    static get requires() {
        return ['TrackChanges', 'UsersIntegration'];
    }

    static get pluginName() {
        return 'TrackChangesIntegration';
    }

    init() {
        const trackChangesPlugin = this.editor.plugins.get('TrackChanges') as TrackChanges;

        // Set the adapter to the `TrackChanges#adapter` property.
        trackChangesPlugin.adapter = {
            getSuggestion: suggestionId => {
                console.log('Getting suggestion', suggestionId);

                return Promise.resolve(this.getSuggestion(suggestionId));
            },

            addSuggestion: suggestionData => {
                console.log('Suggestion added', suggestionData);
                let name = sessionStorage.getItem('commUser2')
                this.setSuggestion(suggestionData.id, suggestionData);
                return Promise.resolve({
                    id: suggestionData.id,
                    type: suggestionData.type,
                    authorId: name,
                    attributes: suggestionData.attributes,
                    createdAt: new Date()     // Should be set on the server side.

                });
            },

            updateSuggestion: (id, suggestionData) => {
                console.log('Suggestion updated', id, suggestionData);
                this.editor.model.change( writer => {
                    //Get selected region
                       let selection =this.editor.model.document.selection;
                   //Get last position in selection
                      const pos = selection.getLastPosition();
                   //Create range based on last position
                      const range = writer.createRange(pos);
                   //Select the newly created range
                     writer.setSelection( range );         
               } );
                this.setSuggestion(id, suggestionData);
                return Promise.resolve();
            }
        };

        // In order to load comments added to suggestions, you
        // should also integrate the comments adapter.
    }

    private getSuggestion(suggestionId: string) {
        //let data=sessionStorage.getItem(suggestionId)? JSON.parse(sessionStorage.getItem(suggestionId)!!): {};console.log(data)
        return sessionStorage.getItem(suggestionId)
            ? JSON.parse(sessionStorage.getItem(suggestionId)!!)
            : {};
    }

    private setSuggestion(suggestionId: string, suggestionData: any) {
        console.log(suggestionData)
        sessionStorage.setItem(suggestionId, JSON.stringify(suggestionData));
    }
}
